__turbopack_context__.v({
  "badge": "ckRvja_badge",
  "card": "ckRvja_card",
  "title": "ckRvja_title",
  "titleRow": "ckRvja_titleRow",
});
